/**
 * Equipment Groups Constants
 *
 * Client-side groups shown in the equipment browser's group tabs after the BFF
 * views. A group id lives in the route `viewId` like a view does; its data is the
 * default (All Equipment) view, narrowed to the group's devices.
 */

/** Route `viewId` values of the client-side groups. */
export const EQUIPMENT_GROUP_IDS = {
  FAULTED: 'faulted',
  MANUAL: 'manual',
} as const;

export type EquipmentGroupId = (typeof EQUIPMENT_GROUP_IDS)[keyof typeof EQUIPMENT_GROUP_IDS];

/** Tab labels; the device count shows beside them as a tab badge. */
export const EQUIPMENT_GROUP_LABELS: Record<EquipmentGroupId, string> = {
  [EQUIPMENT_GROUP_IDS.FAULTED]: 'Faulted',
  [EQUIPMENT_GROUP_IDS.MANUAL]: 'Manual devices',
};
